export default __webpack_public_path__ + "static/media/architecture.cfeb9638.png";